import { u_ } from "@pressmedia/webappbase";

/*----------------
* for aNextStep()
**/
export default {
	nextStepCallBacks: {
		// begin cb if it's input sheet.
		beforeRequestNext($form) {},
		
		// success cb if it's input sheet. (before focus the next sheet.)
		beforeFocusNext(res) {
			// [確認シートへ入力データをコピー]
			this.get(this.confirmSheetName).setState( "copy", this.getActiveSheet() );
		},
		
		// success cb if it's input sheet. (after focus the next sheet.)
		afterFocusNext() {},
		
		// begin cb if it's confirm sheet.
		beforeRequestEdit($form) {},
		
		// success cb if it's confirm sheet.
		editedResponce(res) {
			if( u_.isFunction(this.onSubmitSuccess) ) {
				return this.onSubmitSuccess(this.config, res);
			}
		}
	}
};
